import React, { useState } from 'react';
import './App.css';
import axios from 'axios';

function ResumeUploader() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [ratings, setRatings] = useState<string | null>(null);

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = async (e) => {
    const file = e.target.files?.[0];
    
    // Reset the file input so that choosing the same file again retriggers onChange
    e.target.value = '';

    if (!file) {
      setMessage('Please select a file.');
      return;
    }

    if (file.type !== 'application/pdf') {
      setMessage('Please select a valid PDF file.');
      return;
    }

    setSelectedFile(file);
    setIsLoading(true);
    setMessage('');

    try {
      // Decide base URL based on environment
      const baseUrl =
        process.env.NODE_ENV === 'production'
          ? 'https://api.ridethewave.art'
          : 'http://localhost:8321';

      // Generate a unique filename (e.g., "resume-<timestamp>.pdf")
      const timestamp = Date.now();
      const filename = `resume-${timestamp}.pdf`;

      // Request a pre-signed URL from your backend
      const presignedResponse = await axios.post(`${baseUrl}/api/get-presigned-url`, {
        filename,
        filetype: file.type
      });

      const { url, uploadId: newUploadId } = presignedResponse.data;

      // Use fetch to PUT the file to the provided pre-signed URL
      const uploadResponse = await fetch(url, {
        method: 'PUT',
        headers: { 
          'Content-Type': file.type,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'PUT',  
          'Access-Control-Allow-Headers': '*'
        },
        body: file
      });

      if (!uploadResponse.ok) {
        throw new Error('Failed to upload to Cloudflare R2.');
      }

      // Inform your backend that the file has been uploaded, so it can be processed
      const reviewResponse = await axios.post(`${baseUrl}/api/review-resume`, { fileId: newUploadId });

      console.log('Review response:', reviewResponse.data);

      // Update the ratings with the new data
      const { final_rating, level, reasoning, role } = reviewResponse.data.result;
      const formattedRatings = `Role: ${role}\nLevel: ${level}\nReasoning: ${reasoning}\n\n${final_rating}`;
      setRatings(formattedRatings);
      setMessage(reviewResponse.data.message || '');

      console.log('Updated ratings:', formattedRatings);

    } catch (error) {
      console.error('Upload error:', error);
      setMessage('Error uploading or processing the file.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', margin: 'auto', textAlign: 'center' }}>
      <input
        type="file"
        accept="application/pdf"
        id="file-upload"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <label
        htmlFor="file-upload"
        className="drop-area"
        style={{
          cursor: 'pointer',
          display: 'block',
          padding: '20px',
          border: 'none',
          borderRadius: '10px',
        }}
      >
        {selectedFile ? selectedFile.name : 'Click here to select and upload your PDF resume'}
      </label>
      {message && message !== 'Resume reviewed successfully' && <p>{message}</p>}
      {isLoading && <p className="loading-message">Uploading and processing your file...</p>}
      {ratings && (
        <div className="resume-evaluation" style={{ textAlign: 'left', marginTop: '10px', padding: '20px', border: 'none', borderRadius: '10px', background: '#fff', maxWidth: '1400px', margin: '30px auto', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
          <p style={{ color: '#333', fontSize: '1.5em', marginTop: '0px', marginBottom: '20px' }}>Evaluation</p>
          <article style={{ color: '#555', lineHeight: '1.5', fontSize: '1.1em' }}>
            <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', color: '#555', background: 'none', padding: '0', margin: '0' }}>{ratings}</pre>
          </article>
        </div>
      )}
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <ResumeUploader />
    </div>
  );
}

export default App;